import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { Puzzle, ArrowRight } from 'lucide-react';

const StockDeadstockDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { grampanchayatName, arthikVarshLabel } = location.state || {};

  const dashboardItems = [
    {
      id: 'stock-list',
      title: 'साठा व डेडस्टॉक यादी',
      path: '/panipuravtha/transactions/stock/list',
      color: 'from-blue-500 to-cyan-500',
      description: 'संपूर्ण साठा आणि डेडस्टॉक यादी'
    },
    {
      id: 'supplier-list',
      title: 'पुरवठादार यादी',
      path: '/panipuravtha/transactions/stock/suppliers',
      color: 'from-emerald-500 to-teal-500',
      description: 'नोंदणीकृत पुरवठादारांची माहिती'
    },
    {
      id: 'stock-purchase',
      title: 'साठा खरेदी',
      path: '/panipuravtha/transactions/stock/purchase',
      color: 'from-orange-500 to-amber-500',
      description: 'नवीन साठा खरेदी व्यवहार'
    },
    {
      id: 'deadstock-purchase',
      title: 'डेडस्टॉक खरेदी',
      path: '/panipuravtha/transactions/stock/deadstock-purchase',
      color: 'from-rose-500 to-pink-500',
      description: 'नवीन डेडस्टॉक खरेदी व्यवहार'
    },
    {
      id: 'stock-distribution',
      title: 'साठा वाटप',
      path: '/panipuravtha/transactions/stock/distribution',
      color: 'from-violet-500 to-purple-500',
      description: 'साठा वितरण आणि वापर'
    },
    {
      id: 'deadstock-disposal',
      title: 'डेडस्टॉकची विल्हेवाट',
      path: '/panipuravtha/transactions/deadstock/disposal',
      color: 'from-red-500 to-red-600',
      description: 'डेडस्टॉक निर्लेखन / विल्हेवाट'
    },
    {
      id: 'measurement-info',
      title: 'मोजमाप माहिती',
      path: '/panipuravtha/transactions/stock/measurement',
      color: 'from-indigo-500 to-blue-600',
      description: 'साठा मोजमाप एकके'
    },
    {
      id: 'hsn-info',
      title: 'HSN माहिती',
      path: '/panipuravtha/transactions/stock/hsn',
      color: 'from-cyan-500 to-sky-500',
      description: 'HSN कोड आणि जीएसटी'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-6 md:p-8 font-poppins">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-10">
        <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 flex flex-col md:flex-row justify-between items-center bg-gradient-to-r from-slate-800 to-slate-900 text-white">
          <div className="flex items-center gap-4">
             <button 
                onClick={() => navigate(-1)} 
                className="hover:bg-white/10 p-2 rounded-full transition-colors flex items-center justify-center"
            >
                <FiArrowLeft className="text-2xl" />
            </button>
            <div>
                <h1 className="text-3xl font-bold mb-2">साठा व डेडस्टॉक</h1>
                <p className="text-slate-300">
                {grampanchayatName ? `${grampanchayatName} | ` : ''}आर्थिक वर्ष: {arthikVarshLabel || '२०२४-२५'}
                </p>
            </div>
          </div>
        </div>
      </div>

      {/* Dashboard Grid */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {dashboardItems.map((item) => (
            <div 
                key={item.id}
                onClick={() => navigate(item.path, { state: location.state })}
                className="group cursor-pointer bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden border border-gray-100"
            >
                <div className={`h-2 bg-gradient-to-r ${item.color}`}></div>
                <div className="p-6 text-center flex flex-col items-center">
                    <div className={`w-16 h-16 rounded-xl bg-gradient-to-br ${item.color} flex items-center justify-center text-white mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                        <Puzzle className="w-8 h-8" />
                    </div>
                    <h3 className="text-lg font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors">
                        {item.title}
                    </h3>
                    <p className="text-gray-500 text-xs">
                        {item.description}
                    </p>
                </div>
                <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-between items-center">
                    <span className="text-sm font-medium text-gray-600 group-hover:text-blue-600 transition-colors">
                        निवडा
                    </span>
                    <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-blue-600 transform group-hover:translate-x-1 transition-all duration-300" />
                </div>
            </div>
        ))}
      </div>
    </div>
  );
};

export default StockDeadstockDashboard;
